import * as Sentry from '@sentry/react'

const CLIENT_SIDE = typeof window !== 'undefined'
const isEnabled = () => CLIENT_SIDE && !!CONFIG?.sentry?.dsn

export const init = () => {
  if (process.env.NODE_ENV === 'test') {
    return
  }

  if (!isEnabled()) {
    console.log('Sentry disabled due to config')
    return
  }

  Sentry.init({
    dsn: CONFIG.sentry.dsn,
    debug: CONFIG.sentry?.debug === true,
    environment: process.env.NODE_ENV,
    tunnel: `${CONFIG.apiURL}/sentry/tunnel`,
    sampleRate: 0.05,
    ignoreErrors: [
      'ResizeObserver loop', // browser limitation
      '?(gtag/js)', // crawlers dont like gtm
      'Failed to fetch' // network errors from third-party scripts
    ],
    allowUrls: [/^https:\/\/((cdn(-stage|-sandbox)?|staging|pr-\d+)\.)?scite\.(org|ai)/],
    beforeSend(event, hint) {
      // Ignore errors originating from UserWay widget
      const error = hint.originalException
      const stack = event.exception?.values?.[0]?.stacktrace?.frames || []
      
      // Check if error comes from UserWay CDN
      const isUserWayError = stack.some(frame => 
        frame.filename && frame.filename.includes('cdn.userway.org')
      )
      
      if (isUserWayError) {
        return null // Don't send to Sentry
      }
      
      return event
    }
  })
}

export const setUser = user => {
  if (!isEnabled()) return

  Sentry.setUser({
    id: user.slug,
    username: user.name,
    email: user.email
  })
}

export const handlePageChange = location => {
  if (!isEnabled()) return

  Sentry.setContext('page', {
    path: location.pathname
  })
}

export const captureException = (error, context) => {
  if (!isEnabled()) return

  Sentry.captureException(error, context)
}

export const captureMessage = (message, level = 'info') => {
  if (!isEnabled()) return

  Sentry.captureMessage(message, level)
}
